import {
    IconArchive,
    IconArrowBack,
    IconCheck,
    IconCircleOff,
    IconDeviceFloppy,
    IconEraser, IconEyeSearch,
    IconFileTypePdf,
    IconFolderOpen,
    IconInfoCircle,
    IconPencil,
    IconPlus, IconPower,
    IconPrinter,
    IconSearch,
    IconSend,
    IconSquareRoundedX,
    IconSquareX,
    IconTransfer,
    IconTrash, IconUpload,
    IconX
} from "@tabler/icons-react";

export const HttpVerbo = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    PATCH: 'PATCH'
}
export const TOKEN = 'TOKEN'
export const USUARIO = 'USUARIO'
export const FONTE_FUNDO_A_FUNDO = 49;
export const FONTE_CONVENIO = 50;
export const ENTER = 13;
export const LOCAL_DATE_STRING = "en-CA"
export const IS_MOBILE = ('(max-width: 50em)');
export const COL_RESP_10 = { base: 12, md: 10,  lg: 10 }
export const COL_RESP_8 = { base: 12, md: 8,  lg: 8 }
export const COL_RESP_6 = { base: 12, md: 6,  lg: 6 }
export const COL_RESP_4 = { base: 12, md: 6,  lg: 4 }
export const COL_RESP_3 = { base: 12, md: 4,  lg: 3 }
export const COL_RESP_2 = { base: 12, md: 3,  lg: 2 }
export const COL_RESP_1 = { base: 6, md: 2,  lg: 1 }

export const COR = {
    PRIMARIO: 'blue.7',
    SECUNDARIO: 'gray',
    SUCESSO: 'green.7',
    INFO: 'cyan.7',
    PERIGO: 'red.8',
    ALERTA: 'yellow'
}
export const ICONE = {
    ABRIR: IconFolderOpen,
    ADICIONAR: IconPlus,
    ALTERAR: IconPencil,
    ARQUIVAR: IconArchive,
    ATIVAR: IconPower,
    CANCELAR: IconSquareX,
    EDITAR: IconPencil,
    ENVIAR: IconSend,
    ERRO: IconSquareRoundedX,
    EXCLUIR: IconTrash,
    EXIBIR: IconEyeSearch,
    FECHAR: IconX,
    INATIVAR: IconCircleOff,
    INFO: IconInfoCircle,
    IMPRIMIR: IconPrinter,
    LIMPAR: IconEraser,
    OK: IconCheck,
    PDF: IconFileTypePdf,
    PESQUISAR: IconSearch,
    SALVAR: IconDeviceFloppy,
    TRANSFERIR: IconTransfer,
    UPLOAD: IconUpload,
    VOLTAR: IconArrowBack,
}
